import { Pipe, PipeTransform } from '@angular/core';

import * as dayjs from 'dayjs';

@Pipe({
  standalone: true,
  name: 'tmwDateTime',
})
export default class TmwDateTimePipe implements PipeTransform {
  transform(day: any): string {
    return day ? dayjs(day).format('DD/MM/YYYY HH:mm') : '';
  }
}
